import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Button, MobileStepper } from '@mui/material';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import './resumenIngresoCreationContent.scss';
import { STEPS } from './steps';

import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { adaptAlimentacionEnteral } from '../../../adapters/resumenIngreso/alimentacionEnteralAdapter';
import { adaptAlimentacionParenteral } from '../../../adapters/resumenIngreso/alimentacionParenteralAdapter';
import { adaptCondicionesGeneralesRI } from '../../../adapters/resumenIngreso/condicionesGeneralesRIAdapter';
import { adaptCuidadosDomiciliariosRI } from '../../../adapters/resumenIngreso/cuidadosDomiciliariosRIAdapter';
import { adaptCuidadosPaliativosRI } from '../../../adapters/resumenIngreso/cuidadosPaliativosAdapter';
import { adaptDatosFiliatorios, adaptDireccionRI, adaptPaciente } from '../../../adapters/resumenIngreso/datosFiliatoriosAdapter';
import { adaptDatosGeneralesRI } from '../../../adapters/resumenIngreso/datosGeneralesRIAdapter';
import { adaptDisfagia } from '../../../adapters/resumenIngreso/disfagiaAdapter';
import { adaptKetosteril } from '../../../adapters/resumenIngreso/ketosterilRIAdapter';
import { adaptNPID } from '../../../adapters/resumenIngreso/NPIDAdapter';
import { adaptPantallasRIArray } from '../../../adapters/resumenIngreso/pantallasRIAdapter';
import { adaptProfesionalRI } from '../../../adapters/resumenIngreso/profesionalRIAdapter';
import { adaptRequerimientosAdicionalesRI } from '../../../adapters/resumenIngreso/requerimientosAdicionalesRIAdapter';
import { CREATE_ADICIONAL_RI } from '../../../data/graphQL/mutations/ResumenIngreso/createAdicionalRI';
import { CREATE_PROFESIONALES } from '../../../data/graphQL/mutations/ResumenIngreso/createProfesionales';
import { UPDATE_ALIMENTACION_ENTERAL } from '../../../data/graphQL/mutations/ResumenIngreso/updateAlimentacionEnteralRI';
import { UPDATE_ALIMENTACION_PARENTERAL } from '../../../data/graphQL/mutations/ResumenIngreso/updateAlimentacionParenteral';
import { UPDATE_CONDICION_GENERAL } from '../../../data/graphQL/mutations/ResumenIngreso/updateCondicionGeneral';
import { UPDATE_CUIDADOS_DOMICILIARIOS } from '../../../data/graphQL/mutations/ResumenIngreso/updateCuidadosDomiciliarios';
import { UPDATE_CUIDADOS_PALIATIVOS } from '../../../data/graphQL/mutations/ResumenIngreso/updateCuidadosPaliativos';
import { UPDATE_DATOS_GENERALES_RI } from '../../../data/graphQL/mutations/ResumenIngreso/updateDatosGenerales';
import { UPDATE_DISFAGIA } from '../../../data/graphQL/mutations/ResumenIngreso/updateDisfagia';
import { UPDATE_KETOSTERIL } from '../../../data/graphQL/mutations/ResumenIngreso/updateKetoRI';
import { UPDATE_NPID } from '../../../data/graphQL/mutations/ResumenIngreso/updateNPIDRI';
import { GET_ALIMENTACION_ENTERAL } from '../../../data/graphQL/queries/ResumenIngreso/getAlimentacionEnteralRIByDGId';
import { GET_ALIMENTACION_PARENTERAL } from '../../../data/graphQL/queries/ResumenIngreso/getAlimentacionParenteralRIByDGId';
import { GET_CONDICIONES_GENERALES_RI_BY_ID } from '../../../data/graphQL/queries/ResumenIngreso/getCondicionesGeneralesRIById';
import { GET_CUIDADOS_DOMICILIARIOS_RI_BY_ID } from '../../../data/graphQL/queries/ResumenIngreso/getCuidadosDomiciliariosRIById';
import { GET_CUIDADOS_PALIATIVOS_RI_BY_ID } from '../../../data/graphQL/queries/ResumenIngreso/getCuidadosPaliativosRIById';
import { GET_DATOS_GENERALES_RI_BY_ID } from '../../../data/graphQL/queries/ResumenIngreso/getDatosGeneralesRI';
import { GET_DISFAGIA } from '../../../data/graphQL/queries/ResumenIngreso/getDisfagiaRI';
import { GET_KETO_BY_ID } from '../../../data/graphQL/queries/ResumenIngreso/getKetoRIById';
import { GET_NPID } from '../../../data/graphQL/queries/ResumenIngreso/getNutricionParenteralRI';
import { GET_PANTALLAS_RI } from '../../../data/graphQL/queries/ResumenIngreso/getPantallasRI';
import { GET_PROFESIONALES_RI_BY_ID } from '../../../data/graphQL/queries/ResumenIngreso/getProfesionalesRIByIdDatosGenerales';
import { GET_REQUERIMIENTOS_ADICIONALES_RI_BY_ID } from '../../../data/graphQL/queries/ResumenIngreso/getRequerimientosAdicionalesRIByIdDatosGenerales';
import { getUncompletedRequiredFields } from '../../../helpers/tools';

export const ResumenIngresoCreationContent = () => {
  const dataSubmissionRef = useRef(null);
  const navigate = useNavigate();
  const { state = {} } = useLocation();
  const { idDatosGeneralesRI, edit } = state;

  const [selectedPrograms, setSelectedPrograms] = useState([]);
  const [activeStepIndex, setActiveStepIndex] = useState(0);

  const [modulosOptions, setModulosOptions] = useState([]);
  const [pantallas, setPantallas] = useState([]);

  const [datosFiliatorios, setDatosFiliatorios] = useState([]);
  const [direccionRI, setDireccionRI] = useState({});
  const [paciente, setPaciente] = useState({});

  const [fullFormDataRI, setFullFormDataRI] = useState({});


  const [lugarServicioRIEsDomicilio, setLugarServicioRIEsDomicilio] = useState();

  const [submitLoading, setSubmitLoading] = useState(false);

  const { loading: datosGeneralesLoading, data: datosGeneralesRIData } = useQuery(GET_DATOS_GENERALES_RI_BY_ID, {
    fetchPolicy: 'no-cache',
    variables: { idDatosGenerales: idDatosGeneralesRI },
  });

  useEffect(() => {
    if (!datosGeneralesRIData) return;

    const datosGenerales = adaptDatosGeneralesRI(datosGeneralesRIData);
    setDatosFiliatorios(adaptDatosFiliatorios(datosGeneralesRIData));
    setPaciente(adaptPaciente(datosGeneralesRIData));
    setDireccionRI(adaptDireccionRI(datosGeneralesRIData));
    setFullFormDataRI((prevFullFormDataRI) => ({
      ...prevFullFormDataRI,
      ...datosGenerales
    }));
    setSelectedPrograms(datosGenerales?.datosGenerales1?.selectedPrograms);
  }, [datosGeneralesRIData]);

  const { loading: getPantallasLoading, data: pantallasData } = useQuery(GET_PANTALLAS_RI, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!pantallasData) return;

    const pantallasRI = adaptPantallasRIArray(pantallasData);
    setPantallas(pantallasRI);
    const modulesSet = new Set();
    pantallasRI.forEach((pantalla) => {
      pantalla.modulos.forEach((modulo) => {
        modulesSet.add(JSON.stringify(modulo));
      });
    });
    const uniqueModules = Array.from(modulesSet).
      map((modulo) => JSON.parse(modulo)).
      sort((a, b) => a.id - b.id);

    setModulosOptions(uniqueModules);
  }, [pantallasData]);

  const { loading: getCondGralesLoading, data: condicionesGeneralesRIData } = useQuery(GET_CONDICIONES_GENERALES_RI_BY_ID, {
    fetchPolicy: 'no-cache',
    variables: { idDatosGenerales: idDatosGeneralesRI },
  });

  useEffect(() => {
    if (!condicionesGeneralesRIData) return;

    const condicionesGenerales = adaptCondicionesGeneralesRI(condicionesGeneralesRIData);
    setFullFormDataRI((prevFullFormDataRI) => ({
      ...prevFullFormDataRI,
      ...condicionesGenerales
    }));
  }, [condicionesGeneralesRIData]);

  const programasSeleccionadosAbrev = useMemo(() =>
    modulosOptions?.filter((mo) => selectedPrograms?.includes(mo.id))?.map((mo) => mo.displayName) || [],
    [modulosOptions, selectedPrograms]);

  const programOnlyCP = useMemo(() => {
    return programasSeleccionadosAbrev?.length === 1 && programasSeleccionadosAbrev[0] === 'CP';
  }, [programasSeleccionadosAbrev]);

  useEffect(() => {
    if (!selectedPrograms?.length || !modulosOptions?.length) return;

    if (programasSeleccionadosAbrev.includes('AE') || programasSeleccionadosAbrev.includes('SSAE') || programasSeleccionadosAbrev.includes('CEAE')) {
      getAlimentacionEnteral({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
        if (!data) return;
        const programaAE = adaptAlimentacionEnteral(data);
        setFullFormDataRI((prevFullFormDataRI) => ({
          ...prevFullFormDataRI,
          ...programaAE
        }));
      });
    }

    if (programasSeleccionadosAbrev.includes('AP')) {
      getAlimentacionParenteral({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
        if (!data) return;
        const programaAP = adaptAlimentacionParenteral(data);
        setFullFormDataRI((prevFullFormDataRI) => ({
          ...prevFullFormDataRI,
          ...programaAP
        }));
      });
    }

    if (programasSeleccionadosAbrev.includes('NPID') || programasSeleccionadosAbrev.includes('SIP')) {
      getNpid({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
        if (!data) return;
        const programaNPID = adaptNPID(data);
        setFullFormDataRI((prevFullFormDataRI) => ({
          ...prevFullFormDataRI,
          ...programaNPID
        }));
      });
    }

    if (programasSeleccionadosAbrev.includes('DI')) {
      getDisfagia({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
        if (!data) return;
        const programaDisfagia = adaptDisfagia(data);
        setFullFormDataRI((prevFullFormDataRI) => ({
          ...prevFullFormDataRI,
          ...programaDisfagia
        }));
      });
    }

    if (programasSeleccionadosAbrev.includes('KETO')) {
      getKeto({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
        if (!data) return;
        const ketosteril = adaptKetosteril(data);
        setFullFormDataRI((prevFullFormDataRI) => ({
          ...prevFullFormDataRI,
          ...ketosteril
        }));
      });
    }

    if (programasSeleccionadosAbrev.includes('CD')) {
      getCuidadosDomiciliarios({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
        if (!data) return;
        const cuidadosDomiciliarios = adaptCuidadosDomiciliariosRI(data);
        setFullFormDataRI((prevFullFormDataRI) => ({
          ...prevFullFormDataRI,
          ...cuidadosDomiciliarios
        }));
      });
    }

    if (programasSeleccionadosAbrev.includes('CP') || programasSeleccionadosAbrev.includes('CD')) {
      getCuidadosPaliativos({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
        if (!data) return;
        const cuidadosPaliativos = adaptCuidadosPaliativosRI(data);
        setFullFormDataRI((prevFullFormDataRI) => ({
          ...prevFullFormDataRI,
          ...cuidadosPaliativos
        }));
      }).catch((error) => {
        console.error('Error fetching cuidados paliativos:', error);
      });
    }

    if (programasSeleccionadosAbrev.includes('CP') || programasSeleccionadosAbrev.includes('CD')) {
      getAdicionales({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
        if (!data) return;
        const requerimientosAdicionales = adaptRequerimientosAdicionalesRI(data);
        setFullFormDataRI((prevFullFormDataRI) => ({
          ...prevFullFormDataRI,
          ...requerimientosAdicionales
        }));
      });
    }

    if (programasSeleccionadosAbrev.includes('CEAO') ||
      programasSeleccionadosAbrev.includes('CEAE') ||
      programasSeleccionadosAbrev.includes('CP') ||
      programasSeleccionadosAbrev.includes('CD') ||
      programasSeleccionadosAbrev.includes('AOC')) {
      getProfesionales({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
        if (!data) return;
        const profesionalRI = adaptProfesionalRI(data);
        setFullFormDataRI((prevFullFormDataRI) => ({
          ...prevFullFormDataRI,
          ...profesionalRI
        }));
      });
    }

  }, [selectedPrograms, modulosOptions]);

  const mostrarEspecialistas = useMemo(() => {
    return (
      programasSeleccionadosAbrev.includes('CEAO') ||
      programasSeleccionadosAbrev.includes('CEAE') ||
      programasSeleccionadosAbrev.includes('CD') ||
      programasSeleccionadosAbrev.includes('AOC'));

  }, [selectedPrograms]);

  const [getAlimentacionEnteral, { loading: getAlimentacionEnteralLoading }] = useLazyQuery(GET_ALIMENTACION_ENTERAL, {
    fetchPolicy: 'no-cache'
  });

  const [getAlimentacionParenteral, { loading: getAlimentacionParenteralLoading }] = useLazyQuery(GET_ALIMENTACION_PARENTERAL, {
    fetchPolicy: 'no-cache'
  });

  const [getNpid, { loading: getNpidLoading }] = useLazyQuery(GET_NPID, {
    fetchPolicy: 'no-cache'
  });

  const [getDisfagia, { loading: getDisfagiaLoading }] = useLazyQuery(GET_DISFAGIA, {
    fetchPolicy: 'no-cache'
  });

  const [getKeto, { loading: getKetoLoading }] = useLazyQuery(GET_KETO_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  const [getAdicionales, { loading: getAdicionalesLoading }] = useLazyQuery(GET_REQUERIMIENTOS_ADICIONALES_RI_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  const [getProfesionales, { loading: getProfesionalesLoading }] = useLazyQuery(GET_PROFESIONALES_RI_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  const [getCuidadosDomiciliarios, { loading: getCuidadosDomiciliariosLoading }] = useLazyQuery(GET_CUIDADOS_DOMICILIARIOS_RI_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  const [getCuidadosPaliativos, { loading: getCuidadosPaliativosLoading }] = useLazyQuery(GET_CUIDADOS_PALIATIVOS_RI_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  const queriesLoading = useMemo(() => {
    return (
      datosGeneralesLoading ||
      getPantallasLoading ||
      getCondGralesLoading ||
      getAlimentacionEnteralLoading ||
      getAlimentacionParenteralLoading ||
      getNpidLoading ||
      getDisfagiaLoading ||
      getKetoLoading ||
      getAdicionalesLoading ||
      getProfesionalesLoading ||
      getCuidadosDomiciliariosLoading ||
      getCuidadosPaliativosLoading);

  }, [
    datosGeneralesLoading,
    getPantallasLoading,
    getCondGralesLoading,
    getAlimentacionEnteralLoading,
    getAlimentacionParenteralLoading,
    getNpidLoading,
    getDisfagiaLoading,
    getKetoLoading,
    getAdicionalesLoading,
    getProfesionalesLoading,
    getCuidadosDomiciliariosLoading,
    getCuidadosPaliativosLoading]
  );

  const [updateDatosGenerales] = useMutation(UPDATE_DATOS_GENERALES_RI);
  const [updateCondicionGeneral] = useMutation(UPDATE_CONDICION_GENERAL);
  const [updateProgramaAE] = useMutation(UPDATE_ALIMENTACION_ENTERAL);
  const [updateCuidadosDomiciliarios] = useMutation(UPDATE_CUIDADOS_DOMICILIARIOS);
  const [updateProgramaAP] = useMutation(UPDATE_ALIMENTACION_PARENTERAL);
  const [createProfesionales] = useMutation(CREATE_PROFESIONALES);
  const [createAdicionalRI] = useMutation(CREATE_ADICIONAL_RI);
  const [updateKeto] = useMutation(UPDATE_KETOSTERIL);
  const [updateCuidadosPaliativos] = useMutation(UPDATE_CUIDADOS_PALIATIVOS);
  const [updateNPID] = useMutation(UPDATE_NPID);
  const [updateDI] = useMutation(UPDATE_DISFAGIA);

  const handleChangePrograms = ({ target }) => {
    setSelectedPrograms(target.value);
  };

  const handleNext = () => {
    if (!dataSubmissionRef.current || !edit) return setActiveStepIndex((prevIndex) => prevIndex + 1);

    dataSubmissionRef.current();
  };

  const handleBack = () => {
    setActiveStepIndex((prevIndex) => prevIndex - 1);
  };

  const getMissingFields = (formData, inputs) => {
    const missing = getUncompletedRequiredFields(inputs, formData);
    if (!missing.length)
      return [];

    return missing.map((x) => x.displayName);
  };

  const updateFormData = async (formName, formData, inputs) => {
    if (!!inputs) {
      const missingFields = getMissingFields(formData, inputs);
      if (missingFields?.length > 0) {
        toast.error(`Los siguientes campos son requeridos: ${missingFields.join(', ')}`);

        return 'Error al guardar';
      }
    }

    setSubmitLoading(true);

    try {
      switch (formName) {
        case 'datosGenerales1':
          await updateDatosGenerales({
            variables: {
              screen: 1,
              input: {
                ...formData,
                idDatosGeneralesRI,
                idPaciente: paciente.id,
                edadAnio: paciente.edad,
                edadMeses: paciente.meses,
                nAfiliado: paciente.nroAfiliado,
                telContacto: paciente.telContacto,
                familiarContacto: paciente.familiarContacto
              }
            }
          });
          break;
        case 'datosGenerales2':
          const cloneData = structuredClone({
            ...formData,
            diagnosticosRI: formData.diagnosticosRI?.map((x) => ({
              idDiagnostico: x.codigo,
              idItemDiagnostico: x.codigoItem
            }))
          });
          await updateDatosGenerales({
            variables: {
              screen: 2,
              input: {
                ...cloneData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'datosGenerales3':
          await updateDatosGenerales({
            variables: {
              screen: 3,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'requerimientosAdicionales':
          await createAdicionalRI({
            variables: {
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'programaAE1':
          await updateProgramaAE({
            variables: {
              screen: 1,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });

          await getAlimentacionEnteral({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
            if (!data) return;
            const programaAE = adaptAlimentacionEnteral(data);
            setFullFormDataRI((prevFullFormDataRI) => ({
              ...prevFullFormDataRI,
              ...programaAE
            }));
          });
          break;
        case 'programaAE2':
          await updateProgramaAE({
            variables: {
              screen: 2,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'cuidadosDomiciliarios1':
          await updateCuidadosDomiciliarios({
            variables: {
              screen: 1,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });

          await getCuidadosDomiciliarios({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
            if (!data) return;
            const cuidadosDomiciliarios = adaptCuidadosDomiciliariosRI(data);
            setFullFormDataRI((prevFullFormDataRI) => ({
              ...prevFullFormDataRI,
              ...cuidadosDomiciliarios
            }));
          });
          break;
        case 'cuidadosDomiciliarios2':
          await updateCuidadosDomiciliarios({
            variables: {
              screen: 2,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'programaAP1':
          await updateProgramaAP({
            variables: {
              screen: 1,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });

          await getAlimentacionParenteral({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
            if (!data) return;
            const programaAP = adaptAlimentacionParenteral(data);
            setFullFormDataRI((prevFullFormDataRI) => ({
              ...prevFullFormDataRI,
              ...programaAP
            }));
          });
          break;
        case 'programaAP2':
          const cloneFormData = structuredClone({
            ...formData,
            indicacionRIInput: formData.bAPestandar ? {
              idDatosGeneralesRI,
              idInsumo: formData.idInsumo,
              idPantallaRI: formData.idPantallaRI,
              cantidadDiaria: formData.cantidadDiaria
            } : null
          });
          delete cloneFormData.nombreInsumo;
          delete cloneFormData.idInsumo;
          delete cloneFormData.cantidadDiaria;
          await updateProgramaAP({
            variables: {
              screen: 2,
              input: {
                ...cloneFormData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'programaNPID1':
          await updateNPID({
            variables: {
              screen: 1,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });

          await getNpid({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
            if (!data) return;
            const programaNPID = adaptNPID(data);
            setFullFormDataRI((prevFullFormDataRI) => ({
              ...prevFullFormDataRI,
              ...programaNPID
            }));
          });
          break;
        case 'programaNPID2':
          const cloneNPIDData = structuredClone({
            ...formData,
            indicacionRIInput: formData.bAPestandar ? {
              idDatosGeneralesRI,
              idInsumo: formData.idInsumo,
              idPantallaRI: formData.idPantallaRI,
              cantidadDiaria: formData.cantidadDiaria
            } : null
          });
          delete cloneNPIDData.nombreInsumo;
          delete cloneNPIDData.idInsumo;
          delete cloneNPIDData.cantidadDiaria;
          await updateNPID({
            variables: {
              screen: 2,
              input: {
                ...cloneNPIDData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'programaDI1':
          await updateDI({
            variables: {
              screen: 1,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });

          await getDisfagia({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
            if (!data) return;
            const programaDisfagia = adaptDisfagia(data);
            setFullFormDataRI((prevFullFormDataRI) => ({
              ...prevFullFormDataRI,
              ...programaDisfagia
            }));
          });
          break;
        case 'programaDI2':
          await updateDI({
            variables: {
              screen: 2,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'cuidadosPaliativos1':
          await updateCuidadosPaliativos({
            variables: {
              screen: 1,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });

          await getCuidadosPaliativos({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
            if (!data) return;
            const cuidadosPaliativos = adaptCuidadosPaliativosRI(data);
            setFullFormDataRI((prevFullFormDataRI) => ({
              ...prevFullFormDataRI,
              ...cuidadosPaliativos
            }));
          });
          break;
        case 'cuidadosPaliativos2':
          await updateCuidadosPaliativos({
            variables: {
              screen: 2,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'cuidadosPaliativos3':
          await updateCuidadosPaliativos({
            variables: {
              screen: 3,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'profesionalRI':
          await createProfesionales({
            variables: {
              input: formData,
              idDatosGeneralesRI: idDatosGeneralesRI
            }
          });
          break;
        case 'ketosteril1':
          await updateKeto({
            variables: {
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });

          await getKeto({ variables: { idDatosGenerales: idDatosGeneralesRI } }).then(({ data }) => {
            if (!data) return;
            const ketosteril = adaptKetosteril(data);
            setFullFormDataRI((prevFullFormDataRI) => ({
              ...prevFullFormDataRI,
              ...ketosteril
            }));
          });
          break;
        case 'condicionesGenerales1':
          await updateCondicionGeneral({
            variables: {
              screen: 1,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'condicionesGenerales2':
          await updateCondicionGeneral({
            variables: {
              screen: 2,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          });
          break;
        case 'condicionesGenerales3':
          await updateCondicionGeneral({
            variables: {
              screen: 3,
              input: {
                ...formData,
                idDatosGeneralesRI
              }
            }
          }).then((data) => {
            if (data.errors?.length > 0)
              throw new Error(data.errors[0].message);

            toast.success("El resumen de ingreso del paciente se agrego correctamente.");
            setTimeout(() => navigate('/mistareas'), 1000);
          }).catch((err) => {
            toast.error("Ha ocurrido un error en la creación del resumen de ingreso.");
          });
          return;
        default:
          break;
      }

      setActiveStepIndex((prevIndex) => prevIndex + 1);

      setFullFormDataRI((prevData) => ({
        ...prevData,
        [formName]: formData
      }));

    }
    catch (err) {
      console.log(err);
    } finally {
      setSubmitLoading(false);
    }
  };

  const dynamicProps = {
    selectedPrograms: selectedPrograms,
    handleChangePrograms: handleChangePrograms,
    datosFiliatorios,
    paciente,
    idPaciente: paciente.id,
    modulosOptions,
    esAdulto: paciente.edad > 15,
    fullFormDataRI,
    idDatosGeneralesRI,
    lugarServicioRIEsDomicilio,
    setLugarServicioRIEsDomicilio,
    setDataSubmissionCallback: (callback) => {
      dataSubmissionRef.current = callback;
    },
    updateFormData: (formName, formData, inputs) => updateFormData(formName, formData, inputs),
    edit,
    pantallas,
    submitLoading,
    direccionRI,
    mostrarEspecialistas,
    programasSeleccionadosAbrev,
    programOnlyCP
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStepIndex]);

  const filterStepsByModules = useMemo(() => {
    const selectedPantallas = pantallas.filter((pantalla) =>
      pantalla.modulos.some((modulo) => selectedPrograms.includes(modulo.id))
    );

    let pantallaNames = selectedPantallas.map((pantalla) => pantalla.displayName);

    // no muestro el Step de profesionales si no tengo incluido alguno de esos programas
    if (!programasSeleccionadosAbrev.includes('CEAO') &&
      !programasSeleccionadosAbrev.includes('CEAE') &&
      !programasSeleccionadosAbrev.includes('CD') &&
      !programasSeleccionadosAbrev.includes('AOC'))

      pantallaNames = pantallaNames.filter((p) => p != 'Reco. Prof');

    if (pantallaNames.includes("Cuidados Domiciliario") || pantallaNames.includes("CP"))
      pantallaNames.push("Adicional");

    const filteredSteps = STEPS.filter((step) =>
      (step.general || pantallaNames.includes(step.pantallaName)) && !step.isConditionOfStreetAddress ||
      step.general && step.isConditionOfStreetAddress && lugarServicioRIEsDomicilio
    );

    return filteredSteps.sort((a, b) => a.order - b.order);

  }, [selectedPrograms, pantallas, lugarServicioRIEsDomicilio]);

  const activeStep = filterStepsByModules[activeStepIndex];

  if (!idDatosGeneralesRI) return <div>
    No existe ningún resumen de ingreso
  </div>;

  return (
    <>
      <div className='resumen-ingreso-creation'>
        <div className='resumen-ingreso-mobile' id='contenedorPadre'>
          <div className='progress-bar'>
            <div className='resumen-ingreso-step-title'>
              <label>{activeStep.stepName}</label>
            </div>
            <MobileStepper
              variant='progress'
              steps={filterStepsByModules.length}
              activeStep={activeStepIndex}
              position='static'
              color='success'
              nextButton={
                <Button size='small' onClick={handleNext} disabled={activeStepIndex === filterStepsByModules.length - 1 || submitLoading || queriesLoading}>
                  <KeyboardArrowRight />
                </Button>
              }
              backButton={
                <Button size='small' onClick={handleBack} disabled={activeStepIndex === 0}>
                  <KeyboardArrowLeft />
                </Button>
              } />

          </div>
          {activeStep &&
            <div className='active-step'>
              {React.cloneElement(activeStep.component, { ...dynamicProps })}
            </div>
          }
        </div>
      </div>
    </>);

};